import {
  API_SUCCESS,
  API_FAIL,
  GET_CHARTS_DATA,
  GET_COUNTS_ON_DASHBOARD,
  GET_COUNTS_ON_DASHBOARD_SUCCESS,
  GET_COUNTS_ON_DASHBOARD_FAILED,
} from "./actionTypes"

export const apiSuccess = (actionType, data) => ({
  type: API_SUCCESS,
  payload: { actionType, data },
})

export const apiFail = (actionType, error) => ({
  type: API_FAIL,
  payload: { actionType, error },
})

// charts data
export const getChartsData = periodType => ({
  type: GET_CHARTS_DATA,
  payload: periodType,
})

export const getTotalCountOnDashboard = () => {
  return {
    type: GET_COUNTS_ON_DASHBOARD,
  }
}

export const getTotalCountOnDashboardSuccess = dashboardCounts => {
  return {
    type: GET_COUNTS_ON_DASHBOARD_SUCCESS,
    payload: dashboardCounts,
  }
}

export const getTotalCountOnDashboardFail = error => {
  return {
    type: GET_COUNTS_ON_DASHBOARD_FAILED,
    payload: error,
  }
}
